import { RouteObject } from 'react-router-dom';

import { AdminLayout } from '@/layouts/AdminLayout';
import { WelcomeLayout } from '@/layouts/WelcomeLayout';

import { NotFound } from '@/pages/others/NotFound';
import CompanyInformation from '@/pages/company-profile/CompanyInformation';
import Purpose from '@/pages/company-profile/Purpose';
import Positioning from '@/pages/company-profile/Positioning';
import Vision from '@/pages/company-profile/Vision';
import Mission from '@/pages/company-profile/Mission';
import Culture from '@/pages/company-profile/Culture';
import BusinessGoal from '@/pages/company-profile/BusinessGoal';
import KeyActivities from '@/pages/company-profile/KeyActivities';
import OrganizationStructure from '@/pages/company-profile/OrganizationStructure';
import OrganizationList from '@/pages/company-profile/OrganizationList';
import JobDescription from '@/pages/company-profile/JobDescription';
import Report from '@/pages/company-profile/Report';
import Kpi from '@/pages/company-profile/KPI';
import Reward from '@/pages/company-profile/Reward';
import Punishment from '@/pages/company-profile/Punishment';
import Sop from '@/pages/company-profile/SOP';
import SOPDetail from '@/pages/company-profile/sop/SOPDetail';
import Train from '@/pages/company-profile/Train';
import { ProtectedRoute } from '@/components/shared/gate/ProtectedRoute';
import { Login } from '@/pages/Login/login';
import Callback from '@/pages/Login/callback';
import { ProtectedGlobalRoute } from '@/components/shared/gate/ProtectedGlobalRoute';
import Workspaces from '@/pages/workspaces/Workspaces';

export const routes: RouteObject[] = [
  {
    path: 'login',
    element: <Login />,
  },
  {
    path: 'callback',
    element: <Callback />,
  },
  // {
  //   path: 'demo-share-modal',
  //   element: <ShareModalDemo />,
  // },

  {
    path: '/',
    element: <ProtectedGlobalRoute layout={WelcomeLayout} />,
    children: [
      { index: true, element: <Workspaces /> },
      {
        path: '/workspaces',
        element: <Workspaces />,
      },
    ],
  },
  {
    path: ':tenant_id',
    element: <ProtectedRoute layout={AdminLayout} />,
    children: [
      {
        path: '',
        element: <CompanyInformation />,
      },
      {
        path: 'purpose',
        element: <Purpose />,
      },
      {
        path: 'positioning',
        element: <Positioning />,
      },
      {
        path: 'vision',
        element: <Vision />,
      },
      {
        path: 'mission',
        element: <Mission />,
      },
      {
        path: 'culture',
        element: <Culture />,
      },
      {
        path: 'business-goal',
        element: <BusinessGoal />,
      },
      {
        path: 'organization-structure',
        element: <OrganizationList />,
      },
      {
        path: 'organization-structure/:organizationId',
        element: <OrganizationStructure />,
      },
      {
        path: 'key-activities',
        element: <KeyActivities />,
      },
      {
        path: 'job-description',
        element: <JobDescription />,
      },
      {
        path: 'report',
        element: <Report />,
      },
      {
        path: 'kpi',
        element: <Kpi />,
      },
      {
        path: 'reward',
        element: <Reward />,
      },
      {
        path: 'punishment',
        element: <Punishment />,
      },
      {
        path: 'sop',
        element: <Sop />,
      },
      {
        path: 'sop/:slug',
        element: <SOPDetail />,
      },
      {
        path: 'train',
        element: <Train />,
      },
    ],
  },
  {
    path: '*',
    element: <AdminLayout />,
    children: [{ path: '*', element: <NotFound /> }],
  },
];
